// extracted by mini-css-extract-plugin
export default {"pickable":"PatientOption_pickable__q9VzK","label":"PatientOption_label__tlAuP","active":"PatientOption_active__HUrSD"};